module.exports = __webpack_public_path__ + "static/media/Map_5.cf682cc3.png";